import { ValidationAction } from '@app/features/contracts/validation/validation-action.model';

export const VALIDATION_REQUEST_TYPES = [
  'REX_VALIDATION',
  'DA_VALIDATION',
  'DP_VALIDATION',
  'RRH_VALIDATION',
  'DRH_VALIDATION',
] as const;
export type ValidationRequestType = (typeof VALIDATION_REQUEST_TYPES)[number];

export const VALIDATION_REQUEST_STATUSES = ['PENDING', 'ACCEPTED', 'REFUSED', 'CANCELLED'] as const;
export type ValidationRequestStatus = (typeof VALIDATION_REQUEST_STATUSES)[number];

export interface ValidationRequest {
  id?: string;
  requestedBy: string;
  requestedTo: string;
  type: ValidationRequestType;
  status: ValidationRequestStatus;
  createdAt: string;
  resolvedAt?: string;
  validationActions: ValidationAction[];
}

export interface CreateValidationRequestPayload {
  contractId: string;
  requestedTo: string;
  type: ValidationRequestType;
  comment: string | null;
}

export interface UpdateValidationRequestPayload {
  contractId: string;
  comment: string | null;
}
